/**
 * Snippets API
 * Here is the API DNA
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface MyStatusLine {
  readonly id?: number;
  status?: MyStatusLine.StatusEnum;
  predictionLeft?: number;
  predictionRight?: number;
}
export namespace MyStatusLine {
  export type StatusEnum = 'MISSING' | 'PENDING' | 'CORRECT' | 'INCORRECT' | 'SLEEPING' | 'PARTIAL';
  export const StatusEnum = {
    MISSING: 'MISSING' as StatusEnum,
    PENDING: 'PENDING' as StatusEnum,
    CORRECT: 'CORRECT' as StatusEnum,
    INCORRECT: 'INCORRECT' as StatusEnum,
    SLEEPING: 'SLEEPING' as StatusEnum,
    PARTIAL: 'PARTIAL' as StatusEnum,
  };
}
